
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_1h7dk_svibw_5",
  "placeholder--active": "awsui_placeholder--active_1h7dk_svibw_9",
  "placeholder--hover": "awsui_placeholder--hover_1h7dk_svibw_12",
  "root": "awsui_root_1h7dk_svibw_16",
  "empty": "awsui_empty_1h7dk_svibw_20"
};
  